module.exports = __webpack_public_path__ + "img/people-green-icon.53910831.png";